import React from 'react'
import Icon from '../../components/icon/Icon'

const Toggle = ({ className, click, icon, ...props }) => {
  return (
    <a
      href="#toggle"
      className={className || ''}
      onClick={(ev) => {
        ev.preventDefault()
        click(ev)
      }}
      {...props}
    >
      <Icon name={icon}/>
    </a>
  )
}
export default Toggle
